import { useCallback } from "react";

import getMetricsV2 from "src/organization/pages/project/environment/metrics/api/getMetrics/getMetricsV2";
import { useStubService } from "src/organization/pages/project/environment/metrics/resources/grid/util";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";
import { usePoller } from "src/organization/pages/project/environment/metrics/utils/polling";

import transform, { getDedicatedHost } from "./transform";

type DedicatedPollType = {
  url: string;
  query: any;
  timeFrame: TimeFrameType;
};

const useDedicatedPoll = ({ url, query, timeFrame }: DedicatedPollType) => {
  const services = useStubService().all;

  const formatData = useCallback(
    (data: any[]) => ({
      result: transform(services, data),
      hosts: getDedicatedHost(data)
    }),
    [services]
  );

  const requestFn = useCallback(
    (timeFrame: TimeFrameType | null) =>
      getMetricsV2({ url, query, timeFrame: timeFrame! }),
    [url, query]
  );

  return usePoller({
    timeFrame,
    requestFn,
    formatData
  });
};

export default useDedicatedPoll;
